import api from './api';

export const setKanbanLaneOrder = async (laneOrder, kanbanBoardId) => {
  try {
    const response = await api.post('/company-kanban/lane-order', {
      laneOrder,
      kanbanBoardId
    });
    return response.data;
  } catch (error) {
    console.error('Error setting kanban lane order:', error);
    throw error;
  }
};

export const getKanbanLaneOrder = async (kanbanBoardId) => {
  try {
    const params = {};
    if (kanbanBoardId) {
      params.kanbanBoardId = kanbanBoardId;
    }
    const response = await api.get('/company-kanban/lane-order', { params });
    return response.data.laneOrder;
  } catch (error) {
    console.error('Error getting kanban lane order:', error);
    return null;
  }
};
